import { createSelector } from "reselect";
import moment from "moment";
import "moment/locale/es";
import { ROLES_RAW } from "../../constants/permissions";
moment().locale("es");

/* APP */
export const isUserAuthorized = (state) => state.authorization;
export const getCurrentRoute = (state) => state.currentRoute;
export const getCurrentRouteTitle = createSelector(
  getCurrentRoute,
  (route) => route?.title
);
export const getSideMenuState = createSelector(
  (state) => state.app,
  (app) => app.isCollapsedSideMenu
);
export const getCurrentTheme = (state) => state.currentTheme;

/* PROFILE */
export const getUserProfile = (state) => state.profile;
export const currentUserId = createSelector(
  (state) => state.profile,
  (profile) => profile && profile.id
);
export const getCurrentUserRole = createSelector(getUserProfile, (profile) =>
  !profile ? null : (ROLES_RAW.includes(profile.role) ? profile.role : null)
);

/* NOTIFICATIONS STATE */
export const getNotificationsState = (state) => state.notifications;

/* USERS */
export const getUsers = (state) => state.users;
export const getUsersForm = (state) => state.usersForm;

/* ALERT */
export const getAlerts = (state) => state.alerts;
export const getAlertsForm = (state) => state.alertsForm;

/* ZONES */
export const getZones = (state) => state.zones;
export const getZonesForm = (state) => state.zonesForm;

/* UBICATIONS */
export const getUbications = (state) => state.ubications;
export const getUbicationsForm = (state) => state.ubicationsForm;

/* OBJECTS */
export const getObjects = (state) => state.objects;
export const getObjectsForm = (state) => state.objectsForm;

/* REPORTS */
export const getReports = (state) => state.reports;
export const getReportsForm = (state) => state.reportsForm;

/* RESPONSIBLES */
export const getResponsibles = (state) => state.responsibles;
export const getResponsiblesForm = (state) => state.responsiblesForm;
